export default {
  usergroups: state => state.usergroups,
  selectedUsergroup: state => state.activeUsergroup,
};
